import {ParamsModel} from 'src/app/modules/common/Model'
import {IExportFileState} from 'src/app/modules/network/components/branchless'
import {actionTypes} from './constants'

export const actions = {
  // get ServiceType DATA
  getLeadFormDetail: (params: ParamsModel = {page: 1, limit: 10}) => ({
    type: actionTypes.GET_LEAD_FORM_DETAIL_START,
    payload: params,
  }),
  getLeadFormDetailSuccess: (data: any) => ({
    type: actionTypes.GET_LEAD_FORM_DETAIL_SUCCESS,
    payload: data,
  }),
  getLeadFormDetailFinish: () => ({
    type: actionTypes.GET_LEAD_FORM_DETAIL_FINISH,
  }),

  //Export file csv
  exportFile: (fileName: string, params: ParamsModel) => {
    return {
      type: actionTypes.EXPORT_LEAD_FORM_DETAIL_FILE_START,
      payload: {fileName, params},
    }
  },

  exportFileSuccess: (data: IExportFileState) => ({
    type: actionTypes.EXPORT_LEAD_FORM_DETAIL_FILE_SUCCESS,
    payload: data,
  }),
  exportFileError: () => ({
    type: actionTypes.EXPORT_LEAD_FORM_DETAIL_FILE_FINISH,
  }),
}
